import { api, authToken, workerUserId } from "./client";

export interface AuthSession {
  token: string;
  user: { id: string; email: string | null; firstName: string | null };
}

export async function login(email: string, password: string): Promise<AuthSession> {
  const session = await api<AuthSession>("/api/auth/login", {
    method: "POST",
    body: { email, password },
    authenticated: false,
  });
  authToken.set(session.token);
  workerUserId.set(session.user.id);
  return session;
}

export function signOut(): void {
  authToken.clear();
  workerUserId.clear();
}
